import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

//
import UserMiddlewares from "../../../store/middlewares/UserMiddlewares";

const UpdateProfileImage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const { isError, isLoading, errorMessage } = useSelector(
    (state) => state.user.uploadImage
  );
  const inpurRef = useRef();

  const openImageSelector = () => {
    inpurRef.current.click();
  };

  const uploadImageHandler = (e) => {
    const file = e?.target?.files[0];
    if (file) {
      dispatch(UserMiddlewares.uploadImage(file));
    }
  };

  const removeImageHandler = () => {
    dispatch(UserMiddlewares.removeImage());
  };

  let isDefaultImage;
  if (user?.imageURL) {
    const imageURLArray = user.imageURL.split("/");
    isDefaultImage = imageURLArray[imageURLArray.length - 1] === "avatar.svg";
  }

  return (
    <div>
      <h3>{t("profile.avatarTitleLabel")}</h3>
      <div>
        <img src={user?.imageURL} style={{ width: 200 }} />
      </div>
      {!isDefaultImage && (
        <button onClick={removeImageHandler}>Remove Image</button>
      )}
      {errorMessage && <div className="error-message">{isError}</div>}
      <div className="d-grid gap-2 my-3">
        <input
          type="file"
          ref={inpurRef}
          style={{ display: "none" }}
          onChange={uploadImageHandler}
          multiple={false}
          accept="image/*"
        />
        <button
          className="btn btn-primary"
          onClick={openImageSelector}
          disabled={isLoading}
        >
          {isLoading
            ? t("generalForm.updadingLabel")
            : t("profile.changeAvatarLabel")}
        </button>
      </div>
    </div>
  );
};

export default UpdateProfileImage;
